import { render, staticRenderFns } from "./finproduction.vue?vue&type=template&id=6df92c9e&lang=html&"
import script from "./finproduction.vue?vue&type=script&lang=js&"
export * from "./finproduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports